import * as React from 'react';
import { TagType } from '../enums';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const popupContent = {
    1: {
        title: 'AVEVA SOFTWARE',
        content: <div>Aveva Software helps you make better decisions in real time, operate equipment more efficiently, and collaborate more effectively across all departments.
        <br></br>Achieve engineering and operational excellence with new generation interfaces and a pre-built library of automation standards.
        <br></br>Reap the benefits of IT-OT convergence through seamless integration capabilities. Reduce project risk through seamless
        integration of supervisory, operations and IoT applications with a platform approach.</div>,
        category: 'APPS, ANALYTICS & SERVICES',
        imgSrc: '/images/img1.png'
    }
}


export function getTagUnit(tagType?: number) {
    switch (tagType) {
        case TagType.InternalTemperature:
        case TagType.OutsideTemperature:
            return '°C';
        case TagType.WindSpeed:
            return 'm/s';
        case TagType.Humidity:
            return '%';
        case TagType.Еlectricity:
            return 'kWh';
        case TagType.Water:
        case TagType.Air:
        case TagType.Gas:
            return <span>m<sup>3</sup></span>;
        default:
            return ''
    }
}

export function getWarningIcon(tagType: number, value: number) {
    if (value) {
        switch (tagType) {
            case TagType.InternalTemperature:
                return getIcon(value, 16, 27, 2, 2);
            case TagType.OutsideTemperature:
                return getIcon(value, 10, 35, 5, 5);
            case TagType.WindSpeed:
                return getIcon(value, 0, 10, 0, 2);
            case TagType.Humidity:
                return getIcon(value, 30, 60, 15, 5);
            default:
                return null;
        }
    }
}

function getIcon(value: number, minValue: number, maxValue: number, deltaMin: number, deltaMax) {
    // In range
    if (value >= minValue + deltaMin && value <= maxValue - deltaMax) {
        return null
    }

    // Out of range
    if (value < minValue || value > maxValue) {
        return <FontAwesomeIcon icon={faExclamationTriangle} color={'#ce1b00'} />
    }

    // Close to limits
    return <FontAwesomeIcon icon={faExclamationTriangle} color={'#ffff40'} />
}